module.exports = __webpack_public_path__ + "img/q-10-2@2x.1e5d004d.png";